import { put, delay, takeLatest, takeEvery } from "redux-saga/effects";
import * as actionTypes from "../actionTypes";
import { showNotification, hideNotification } from "../actions";

let nextNotificationId = 0;
function* showNotificationWithTimeout(action) {
  const id = nextNotificationId++;
  yield put(showNotification(id, action.text, action.msgtype));
  yield delay(5000);
  yield put(hideNotification(id));
}

function* emptyToastMsg() {
  yield put({ type: "EMPTY_TOAST_MSG" });
}

export default function* toastActionWatcher() {
  yield takeEvery(actionTypes.EMPTY_TOAST_MSG, emptyToastMsg);
  yield takeEvery(
    actionTypes.SHOW_NOTIFICATION_WITH_TIMEOUT,
    showNotificationWithTimeout
  );
}
